import type { FlightStatus } from '@skyscanner-internal/landing-pages-shared-types/types-shared/ArrivalsDepartures';
import type { StringTranslations } from '@skyscanner-internal/landing-pages-shared-types/types-shared/components';
import type { KnownStringKeys } from '@skyscanner-internal/landing-pages-shared-types/types-shared/services/saas';

export const STATUS: Record<FlightStatus, KnownStringKeys<'falcon'>> = {
  CANCELLED: 'falcon_adb_flightStatus_status_cancelled',
  DELAYED: 'falcon_adb_flightStatus_status_delayed',
  EXPECTED: 'falcon_adb_flightStatus_status_expected',
  IN_AIR: 'falcon_adb_flightStatus_status_inAir',
  IN_GATE: 'falcon_adb_flightStatus_status_inGate',
  LANDED: 'falcon_adb_flightStatus_status_landed',
  NO_TAKEOFF_INFO: 'falcon_adb_flightStatus_status_noTakeoffInfo',
  OUT_GATE: 'FlightTrackerFlight_status_value_out_gate',
  PAST_FLIGHT: 'falcon_adb_flightStatus_status_pastFlight',
  SCHEDULED: 'falcon_adb_flightStatus_status_scheduled',
  UNKNOWN: 'falcon_adb_flightStatus_status_unknown',
};

export const getTranslatedStatus = (
  status: FlightStatus,
  strings: StringTranslations,
) => strings[STATUS[status]] || strings[STATUS.UNKNOWN] || '??';
